import React, { useState } from "react";
import CountryDropdown from "./countryDropdown";

const PhoneInput = ({ value, onChange }) => {
	const defaultCountry = { dial_code: "+1", emoji: "🇺🇸" }; // Default to US
	const [selectedCountry, setSelectedCountry] = useState(defaultCountry);

	const handleCountryChange = (country) => {
		const numberWithoutCode = value.replace(selectedCountry.dial_code, "");
		setSelectedCountry(country);
		onChange(`${country.dial_code}${numberWithoutCode}`);
	};

	const handleInputChange = (e) => {
		const inputValue = e.target.value;
		const numericValue = inputValue.replace(/\D/g, ""); // Remove all non-numeric characters
		onChange(`${selectedCountry.dial_code}${numericValue}`);
	};

	return (
		<div className="w-full flex items-center bg-white text-black relative border rounded px-3 py-4">
			<CountryDropdown onSelectCountry={handleCountryChange} />
			<span className="ml-2 mr-1 select-none border-b border-transparent">{selectedCountry.dial_code}</span>
			<input
				type="tel"
				value={value.replace(selectedCountry.dial_code, "")}
				onChange={handleInputChange}
				placeholder="Phone Number"
				className="w-full focus-within:outline-none focus-within:border-gray-300 border-b border-transparent"
			/>
		</div>
	);
};

export default PhoneInput;
